module.exports = __webpack_public_path__ + "img/header-logo2.2f9907bd.png";